import React from 'react';
import MiniBarChart from './MiniBarChart';

function AtTheShowsCard({ totalEvents, ticketsCount, lifetimeSpend, showsByYear = [], viewHref }) {
  if (!totalEvents) return null;

  const bars = showsByYear.map((y) => ({
    label: `'${String(y.year).slice(2)}`,
    value: y.count,
  }));

  const countFormatter = (value) => `${value} show${value === 1 ? '' : 's'}`;

  return (
    <div className="cdp-card">
      <div className="cdp-card-header-row">
        <h2 className="cdp-card-title">Events</h2>
        {viewHref && <a href={viewHref} className="cdp-card-view-link">View all</a>}
      </div>

      <div className="cdp-stat-value">{totalEvents} show{totalEvents === 1 ? '' : 's'}</div>
      <div className="cdp-stat-label">{ticketsCount} tickets · {lifetimeSpend}</div>

      <MiniBarChart bars={bars} color="var(--sl-fg-success)" valueFormatter={countFormatter} />
    </div>
  );
}

export default AtTheShowsCard;
